const getPageSize = () => 10

export default getPageSize
